import PolicyLink from "../../components/PolicyLink";

export default function FreidaMcFaddenHub({darkMode}) {
    return (
        <div className={`flex flex-col items-center ${darkMode ? 'dark' : ''}`}>
            <h2 className='font-bold text-center'>Freida McFadden Hub</h2>
            <h3>Screenshots</h3>
            <div className="flex flex-row flex-wrap">
                <img className="m-2 w-36" alt="app screenshot" src="/freida-mcfadden-hub-screens/IMG_5721.png" />
                <img className="m-2 w-36" alt="app screenshot" src="/freida-mcfadden-hub-screens/IMG_5722.png" />
                <img className="m-2 w-36" alt="app screenshot" src="/freida-mcfadden-hub-screens/IMG_5723.png" />
            </div>
        </div>
    )
}
